import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { Data } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { CelebrationAnimationService } from "@core/celebration-animation.service";
import { BehaviorSubject, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { GamesRepositoryService } from "src/app/pages/games/games-repository.service";
import { IonicModule } from "@ionic/angular";
import { NgStyle, AsyncPipe } from "@angular/common";
import { TranslatePipe } from "@ngx-translate/core";
import { GameCelebrationService } from "src/app/pages/games/services/game-celebration.service";

@Component({
    selector: "app-vip-status",
    templateUrl: "./vip-status.component.html",
    styleUrls: ["./vip-status.component.scss"],
    standalone: true,
    imports: [
        IonicModule,
        NgStyle,
        AsyncPipe,
        TranslatePipe,
    ],
})
export class VipStatusComponent implements OnInit {
  public showVideo: boolean;
  public showCard: boolean;
  public vipStatus: Data;
  public vipStatusRank: string;
  public newLevel: string;
  public vipLevelUp: string;
  public videoPath: SafeResourceUrl;
  public textColors = {};
  public titleColor = {};
  /** One-shot lock so OK cannot re-fire close / celebration updates. */
  public isClosing = false;
  @ViewChild("videoPlayer") videoPlayer: ElementRef;
  @ViewChild("videoWrapper") videoWrapper: ElementRef;
  public rankLevelData$ = new BehaviorSubject({});
  public userDetails$ = new BehaviorSubject({});
  constructor(
    private celebrationAnimationService: CelebrationAnimationService,
    private matDialogRef: MatDialogRef<VipStatusComponent>,
    private gamesRepositoryService: GamesRepositoryService,
    private authService: AuthService,
    private sanitizer : DomSanitizer,
    private gameCelebrationService : GameCelebrationService,
    @Inject(MAT_DIALOG_DATA) public data: Data
  ) {
    // This method is used to get data from the Global Gamification Ranks Data
    this.authService.userDetails$
      .pipe(
        catchError((error) => {
          // Handling the error
          return throwError(error);
        })
      )
      .subscribe((res: Data) => {
        this.userDetails$.next(res);
      });
    // This variable contain textColors of User name
    this.textColors = {
      Gold: "#b97e1d",
      Platinum: "#4554b4",
      Diamond: "#fcfcfd",
      "Black Diamond": "#fff9af",
      "Purple Diamond ": "#ffc2ff",
      Silver: "#7b788e",
    };
    // This variable contain titleColors of VIP status title
    this.titleColor = {
      Silver: "#C5C9D8",
      Gold: "#E9D896",
      Platinum: "#A8C3EC",
      Diamond: "#B8B6F4",
      "Black Diamond ": "#FFF8AF",
      "Purple Diamond": "#FFBCFF",
    };
    // This variables contain vipStatus ,vipStatusRank ,currentLevel ,videoType and videoPath
    this.vipStatus = data?.vipCelebration;
    this.videoPath = this.sanitizer.bypassSecurityTrustResourceUrl(data?.vipCelebration?.path);
    this.vipStatusRank = data?.vipStatusRank;
    const currentLevel = data?.vipCelebration?.new_level;
    const videoType = data?.vipCelebration?.type;

    // This method is used to get vip_status levels data from the Global Gamification Ranks Data
    this.celebrationAnimationService
      .globalGamificationVipStatusRanksData(currentLevel)
      .pipe(
        catchError((error) => {
          return throwError(error);
        })
      )
      .subscribe((res: Data) => {
        try {
          this.rankLevelData$.next(res);
        } catch (error) {
          return throwError(error);
        }
      });

    // This method is used to check the video type
    if (videoType === "video") {
      this.playVideo();
      setTimeout(() => {
        if (this.videoWrapper?.nativeElement) {
          this.videoWrapper.nativeElement.style.display = "none";
        }
        this.showCard = true;
      }, 8000);
    } else {
      // Non-video: show the Congratulations card. Closing immediately left
      // processed_status false and caused the popup to reopen / flicker.
      this.showCard = true;
    }
  }
  // This method is used to play the video
  playVideo() {
    setTimeout(() => {
      const video = this.videoPlayer.nativeElement as HTMLVideoElement;
      video.muted = true;
      video.play();
    }, 2000);
  }

  // This method is used to close the dialog
  closeDialog() {
    if (this.isClosing) {
      return;
    }
    this.isClosing = true;
    // Block trackCelebrations from reopening while Firestore catches up.
    this.celebrationAnimationService.markVipCelebrationDismissed();
    // This method is used to update the vip status
    if (this.vipStatusRank !== null && this.vipStatusRank !== undefined) {
      this.gameCelebrationService.updateVipStatusDetailsData(
        this.vipStatusRank
      );
    } else {
      throw new Error("celebrationType is not defined");
    }
    // This methods update the currentCelebration document processed_status = true
    this.gameCelebrationService.updateCurrentCelebrationDocument();
    this.matDialogRef.close();
  }

  ngOnInit() {
    // empty
  }
}
